__turbopack_context__.v({
  "day": "hours-month-visual-module__iBpp1W__day",
  "dayHead": "hours-month-visual-module__iBpp1W__dayHead",
  "dayLanded": "hours-month-visual-module__iBpp1W__dayLanded",
  "dayLandedOver": "hours-month-visual-module__iBpp1W__dayLandedOver",
  "dayOutside": "hours-month-visual-module__iBpp1W__dayOutside",
  "dayTotal": "hours-month-visual-module__iBpp1W__dayTotal",
  "entries": "hours-month-visual-module__iBpp1W__entries",
  "entry": "hours-month-visual-module__iBpp1W__entry",
  "entryHours": "hours-month-visual-module__iBpp1W__entryHours",
  "entryName": "hours-month-visual-module__iBpp1W__entryName",
  "entryPending": "hours-month-visual-module__iBpp1W__entryPending",
  "footer": "hours-month-visual-module__iBpp1W__footer",
  "footerRight": "hours-month-visual-module__iBpp1W__footerRight",
  "gutter": "hours-month-visual-module__iBpp1W__gutter",
  "monthTotalLit": "hours-month-visual-module__iBpp1W__monthTotalLit",
  "monthTotalLitOver": "hours-month-visual-module__iBpp1W__monthTotalLitOver",
  "root": "hours-month-visual-module__iBpp1W__root",
  "total": "hours-month-visual-module__iBpp1W__total",
  "totalLive": "hours-month-visual-module__iBpp1W__totalLive",
  "totalOver": "hours-month-visual-module__iBpp1W__totalOver",
  "week": "hours-month-visual-module__iBpp1W__week",
  "weekNr": "hours-month-visual-module__iBpp1W__weekNr",
  "weekTotal": "hours-month-visual-module__iBpp1W__weekTotal",
  "weekday": "hours-month-visual-module__iBpp1W__weekday",
  "weekdays": "hours-month-visual-module__iBpp1W__weekdays",
});
